enum SharedRoutePath {
  LOGIN = '/login',
  SIGN_UP = '/sign-up',
  ERROR = '/error',
  CHANGE_PASSWORD = '/change-password',
  FORCE_NEW_PASSWORD = '/force-new-password',
  WELCOME = '/welcome',
  PRIVACY_POLICY = '/privacy-policy',
  TERMS_Of_USE = '/terms-of-use',
  EXTERNAL_RETURN = '/3rd-party-sign-in',

  CHAT = '/chat',
  CHAT_LIST = '/chat-list',
  HOME = '/',
  RESET_PASSWORD = '/reset-password',
  CONFIRM_PASSWORD = '/reset',
  VIEW_MANUAL = '/view-manual',
}

export default SharedRoutePath;
